// Libs
import React from 'react';

// Components
import ToolbarPopupTool from '../ToolbarPopupTool';
import MorePopup from './MoreToolPopup';

// Styles
import { ToolbarItemConfig } from '../../toolbarTypes';
import Icon from '../../../../components/icons/Icon';

// Hooks
import { useFocusActiveTiptapEditorOnTouch } from '../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

import './MoreTool.scss';

const MoreTool = (props: { item: ToolbarItemConfig }): React.ReactElement => {

    const focusEditorOnOpen = useFocusActiveTiptapEditorOnTouch();

    return (
        <ToolbarPopupTool
            {...props}
            id={props.item.uid}
            popupId={props.item.uid}
            toolName="more"
            preventFocus
            onToggle={focusEditorOnOpen}
            name=""
            PopupComponent={MorePopup}
        >
            <Icon name="toolbar-more" />
        </ToolbarPopupTool>
    );
};

export default MoreTool;
